import { render, staticRenderFns } from "./orderOilList.vue?vue&type=template&id=d0b1c45e&scoped=true"
import script from "./orderOilList.vue?vue&type=script&lang=js"
export * from "./orderOilList.vue?vue&type=script&lang=js"
import style0 from "./orderOilList.vue?vue&type=style&index=0&id=d0b1c45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b1c45e",
  null
  
)

export default component.exports